import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/macro';
import { Link } from '@toqio/toqio-web-components';

const Root = styled(Link)`
  align-self: flex-start;
`;

export type BackButtonProps = {
  onClick: () => void;
  /** Override the default "Back" label (e.g. a flow-specific translation). */
  label?: React.ReactNode;
};

/** Link-styled "Back" control with a chevron, matching lum-web's back link. */
export const BackButton: React.FC<BackButtonProps> = ({ onClick, label }) => (
  <Root icon="icn_chevron_left" onClick={onClick}>
    {label ?? <Trans>Back</Trans>}
  </Root>
);
